import httpClient from './httpClient';

const getUser = () => httpClient.get('/v1/profile/').then((resp) => resp.data);

const setUserTimezone = (timezone) => httpClient.post('/v1/user_timezone_info/', timezone);

export default {
  setUserTimezone,
  getUser,
};
